export const CloudSolutionsLayout = {
  slots: [
    'SlbCloudSolutionsPdpSlot',
    'SlbBlueBottomBannerSlot'
  ],
};

export const CloudSolutionsPdpLayout = {
  slots: [
    'SlbSubscriptionsPdpFeatureSlot',
  ],
};
